<div class="flex flex-col w-full">
  <app-breadcrumb [items]="breadcrumbs" />

  <div class="flex flex-col gap-1 mt-4 mb-8">
    <h2>{{ 'pages.settings.userManagement.title' | translate }}</h2>
    <p class="text-sm text-shikenso-gray-600">{{ 'pages.settings.userManagement.description' | translate }}</p>
  </div>

  <mat-tab-group class="w-full profile-tab-group" data-testid="user-management">
    <mat-tab>
      <ng-template mat-tab-label>
        <span data-testid="user-management-tab-users">{{
          'pages.settings.userManagement.tabs.users' | translate
        }}</span>
      </ng-template>

      <div class="min-h-[calc(100vh-400px)] pt-7">
        <app-user-management-users-tab data-testid="user-management-tab-panel-users" />
      </div>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <span data-testid="user-management-tab-roles-teams">{{
          'pages.settings.userManagement.tabs.rolesTeams' | translate
        }}</span>
      </ng-template>

      <div class="min-h-[calc(100vh-400px)] pt-7">
        <app-user-management-roles-teams-tab data-testid="user-management-tab-panel-roles-teams" />
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
